const primaryMain = '#0C2340';
const primaryMainOpacity = 'rgba(12, 35, 64, 0.9)';
const secondaryMain = '#FFD100';
const secondaryMainOpacity = 'rgba(255, 209, 0, 0.5)';
const secondaryLight = '#FFD100';
const tertiaryMain = '#D1D2D4';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
